import React from 'react';
import { translateBlock } from 'i18n';
import Typography from '@mui/material/Typography';
import Fields from './Fields';
import TreeItemField from './TreeItemField';
import { TreeValue } from '../contexts/TreeValueContext';
import { TreeItem } from '@mui/x-tree-view';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';

type Props = {
    treeData: FlowAnyObject;
    onClick: FlowAnyFunction;
    domain: string;
    category: string;
    testid: string;
};

const Tables = ({
    treeData,
    onClick,
    domain,
    category,
    testid,
}: Props): React.ReactElement => {
    const sortedTreeData = Object.keys(treeData[domain][category])
        .map((table) => ({
            value: table,
            label: translateBlock(table as string),
        }))
        .sort((a, b) => (a.label > b.label ? 1 : -1));
    const renderTable = (table: { value: string; label: string }) => (
        <TreeItem
            key={table.value}
            nodeId={`${domain}-table-${table.value}`}
            label={
                <Typography variant="body1">
                    {capitalizeAndKeepTheRest(table.label)}
                </Typography>
            }
        >
            <Fields
                treeData={treeData}
                onClick={onClick}
                domain={domain}
                category={category}
                table={table.value}
                testid={testid}
            />
        </TreeItem>
    );

    const renderField = (fieldValue: TreeValue) => {
        const field = treeData[domain][category][fieldValue];
        return (
            <TreeItemField
                key={field.field}
                field={field}
                domain={domain}
                onClick={onClick}
                testid={testid}
            />
        );
    };

    return (
        <>
            {sortedTreeData.map((element: { value: string; label: string }) => {
                const isTable = Array.isArray(
                    treeData[domain][category][element.value],
                );
                return isTable
                    ? renderTable(element)
                    : renderField(element.value);
            })}
        </>
    );
};

export default Tables;
